import ReactGA from "react-ga4";
 
const GA_MEASUREMENT_ID = "G-ZLNG4ENGNP";
 
export const initGA = () => {
  ReactGA.initialize(GA_MEASUREMENT_ID);
};
 
export const trackPageView = (path) => {
  ReactGA.send({
    hitType: "pageview",
    page: path,
  });
};
 
export const trackEvent = (eventName, eventParams = {}) => {
  ReactGA.event(eventName, eventParams);
};
 